import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';
import {
  FETCH_CANDIDATE_LICENSES_ACTION,
  FETCH_JOB_ACTION,
  FETCH_PROFESSIONAL_PROFILE,
  fetchCandidatesLicenses,
  fetchJob,
  fetchProfessionalProfile,
  getAllPaymnets,
} from '~/actions';
import { Box, CardSpinner, Column, Grid, ScreenTitle } from '~/commonComponents';
import { Colors } from '~/themes/colors';
import { BadgesCard } from './components/BadgesCard/BadgesCard';
import { ProfileCard } from './components/ProfileCard/ProfileCard';
import { getShouldUsingCredentialServiceEndpointForLicense } from '~/growthbook';
import { useAppSelector } from '~/hooks/useAppSelector';
import { useLoading } from '~/hooks';

const actions = [FETCH_JOB_ACTION, FETCH_PROFESSIONAL_PROFILE, FETCH_CANDIDATE_LICENSES_ACTION];

export const ProfessionalProfile = () => {
  const hasFetchedPayment = useRef(false);
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isLoading } = useLoading(actions);

  const { jobId, professionalId } = params || {};

  const job = useAppSelector((state) => state.job.job);
  const professional = useAppSelector((state) => state.user.professionalProfile);
  const payments = useAppSelector((state) => state.payments.allPayments);

  const candidateId = professionalId || location?.state?.candidateId;
  const profession = location?.state?.profession || professional?.license?.profession;
  const state =
    location?.state?.state || professional?.address?.[0]?.state || professional?.license?.state;

  useEffect(() => {
    if (!payments?.length && !hasFetchedPayment.current) {
      dispatch(getAllPaymnets());
      hasFetchedPayment.current = true;
    }
  }, [dispatch, payments]);

  useEffect(() => {
    if (candidateId) {
      dispatch(fetchProfessionalProfile(candidateId));
    }
  }, [candidateId, dispatch]);

  useEffect(() => {
    if (candidateId && getShouldUsingCredentialServiceEndpointForLicense()) {
      dispatch(fetchCandidatesLicenses({ candidateId, profession, state }));
    }
  }, [dispatch, candidateId, profession, state]);

  useEffect(() => {
    if (jobId) {
      dispatch(fetchJob({ jobId }));
    }
  }, [jobId, dispatch]);

  if (isLoading || !professional) {
    return <CardSpinner />;
  }

  return (
    <Box className="component_container">
      <Column className="floating_container" width="auto" flex={1}>
        <ScreenTitle title="Professional Profile" onBackClick={() => navigate(-1)} />

        <Column
          marginHorizontal={48}
          marginBottom={40}
          paddingBottom={40}
          backgroundColor={Colors.neutral_50}
          paddingHorizontal={32}
          paddingTop={32}
        >
          {/* @ts-expect-error - missing types */}
          <Grid gridTemplateColumns="1fr 1fr" gridColumnGap={12}>
            <ProfileCard professional={professional} job={jobId ? job : null} />
            <Column gap={12}>
              <BadgesCard professional={professional} />
            </Column>
          </Grid>
        </Column>
      </Column>
    </Box>
  );
};
